import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {TimeRangeParam} from '../../../editors/commons/paramModel';
import {currentTimezone, parseHHMM, TimeAmPm, to24HHMM} from '../../ruleTimeHelpers';
import {StyledNumberLabel} from './genericInput';
import {InputTimeAMPM} from './inputAMPM';

/*
 * Types.
 */

interface InputTimeRangeProps {
  range?: TimeRangeParam;
  isDisabled?: boolean;
  setRange: HandlerOf<TimeRangeParam>;
}

/*
 * Component.
 */

export const InputTimeRange: FC<InputTimeRangeProps> = (props) => {
  const {range, isDisabled, setRange} = props;

  // @RULES TODO: Reformat params to camelCase
  // eslint-disable-next-line camelcase
  const [startTime, setStartTime] = useState(range?.start_time ? parseHHMM(range.start_time) : undefined);

  // eslint-disable-next-line camelcase
  const [endTime, setEndTime] = useState(range?.end_time ? parseHHMM(range.end_time) : undefined);

  const setTime = (kind: 'start' | 'end') => (time: TimeAmPm) => {
    let start = startTime;
    let end = endTime;

    if (kind === 'start') {
      start = time;
      setStartTime(time);
    }

    if (kind === 'end') {
      end = time;
      setEndTime(time);
    }
    if (!start || !end) {
      return;
    }

    // eslint-disable-next-line camelcase
    const start_time = to24HHMM(start);
    // eslint-disable-next-line camelcase
    const end_time = to24HHMM(end);

    // eslint-disable-next-line camelcase
    if (!start_time || !end_time) {
      return;
    }

    const timezone = range?.timezone || currentTimezone();

    // eslint-disable-next-line camelcase
    setRange({start_time, end_time, timezone});
  };

  return (
    <>
      <InputTimeAMPM time={startTime} setTime={setTime('start')} isDisabled={isDisabled} />
      <StyledNumberLabel>
        <Trans id="rules-time-range-and">and</Trans>
      </StyledNumberLabel>
      <InputTimeAMPM time={endTime} setTime={setTime('end')} isDisabled={isDisabled} />
    </>
  );
};
